import React from "react";
import { TrendingDown, TrendingUp, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";
import "../GameDashboard.css";

const StatSubValue = ({ label, value, prefix, suffix }) => {
  const displayValue = `${prefix || ""}${value}${suffix || ""}`;
  return (
    <div className="stat-subvalue-item">
      {label && <span className="subvalue-label">{label}:</span>}
      <span className={`metric-value ${value < 0 ? "negative" : "positive"}`}>
        {value > 0 ? "+" : ""}
        {displayValue}
      </span>
    </div>
  );
};

const StatBox = ({
  icon: Icon,
  label,
  value,
  subValues = [],
  className = "",
  trend,
  onClick,
  info,
}) => (
  <div
    className={`stat-box relative ${onClick ? "clickable" : ""} ${className}`}
    onClick={onClick}
  >
    <div className="stat-content">
      <div className="stat-info">
        <div className="stat-header">
          <span className="stat-label">{label}</span>
          {trend !== undefined &&
            (trend > 0 ? (
              <TrendingUp className="trend-icon trend-up" />
            ) : (
              <TrendingDown className="trend-icon trend-down" />
            ))}
        </div>

        <div className="stat-value">{value}</div>

        <div className="stat-subvalues">
          {subValues.map((subValue, index) => (
            <StatSubValue
              key={index}
              label={subValue.label}
              value={subValue.value}
              trend={subValue.trend}
              prefix={subValue.prefix}
              suffix={subValue.suffix}
              positive={subValue.positive}
            />
          ))}
        </div>
      </div>
    </div>
    <div className="stat-icons">
      <div className="stat-icon-wrapper">
        {Icon && (
          <div className="stat-icon-wrapper">
            <Icon className="stat-icon" />
          </div>
        )}
      </div>
      {info && (
        <div className="info-button-wrapper">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <Info size={20} />
              </TooltipTrigger>
              <TooltipContent>
                <p>{info}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </div>
  </div>
);

export default StatBox;
